module.exports = __webpack_public_path__ + "static/media/app-store.df2e0638.png";